import React, { useMemo, useEffect } from 'react';
import CustomTimeline from 'react-fast-timeline';
import './fast-timeline.css';
import { useTranslation } from 'react-i18next';
import './InteractiveTimeline.css';


const shiftToBrowserLocal = (isoString) => {
    if (!isoString) return 0;
    const d = new Date(isoString);
    return new Date(
        d.getUTCFullYear(),
        d.getUTCMonth(),
        d.getUTCDate(),
        d.getUTCHours() + 3,
        d.getUTCMinutes(),
        d.getUTCSeconds(),
        d.getUTCMilliseconds()
    ).getTime();
};

const shiftFromBrowserLocalToIso = (localMs) => {
    const d = new Date(localMs);
    const utcMs = Date.UTC(
        d.getFullYear(),
        d.getMonth(),
        d.getDate(),
        d.getHours() - 3,
        d.getMinutes(),
        d.getSeconds(),
        d.getMilliseconds()
    );
    return new Date(utcMs).toISOString();
};

const InteractiveTimeline = ({ timelineData, dateRange, onItemDoubleClick, classIdToMeta, initialCenterTime }) => {
    const { t } = useTranslation();

    const items = useMemo(() => {
        if (!timelineData || timelineData.length === 0) return [];

        return timelineData.map((segment, index) => {
            const meta = classIdToMeta[segment.class_id] || classIdToMeta.default;
            
            const startMs = shiftToBrowserLocal(segment.start);
            const endMs = shiftToBrowserLocal(segment.end);

            let label = meta.label;
            if (segment.people_count > 0) {
                label = `${meta.label} (max ${segment.people_count})`;
            }

            return {
                id: index,
                start: startMs,
                end: endMs,
                color: meta.color,
                label: label,
                originalSegment: segment
            };
        });
    }, [timelineData, classIdToMeta]);

    const { initialStart, initialEnd } = useMemo(() => {
        let start = Date.now() - 4 * 3600 * 1000;
        let end = Date.now();

        if (dateRange?.start && dateRange?.end) {
            start = shiftToBrowserLocal(dateRange.start);
            end = shiftToBrowserLocal(dateRange.end);
        }

        if (initialCenterTime) {
            const center = shiftToBrowserLocal(initialCenterTime);
            start = center - 2 * 3600 * 1000;
            end = center + 2 * 3600 * 1000;
        }

        return { initialStart: start, initialEnd: end };
    }, [dateRange, initialCenterTime]);


    const handleDoubleClick = ({ exactTime, item }) => {
        if (onItemDoubleClick) {
            const exactTimeIso = shiftFromBrowserLocalToIso(exactTime);
            const itemId = item ? item.id : null;
            onItemDoubleClick(itemId, exactTimeIso);
        }
    };

    if (!timelineData || items.length === 0) {
        return <p className="text-center text-muted p-3">{t('camera.no_videos')}</p>;
    }

    return (
        <div style={{ height: '180px', width: '100%', borderRadius: '6px', overflow: 'hidden', border: '1px solid #d8dbe0' }}>
            <CustomTimeline
                items={items}
                initialStart={initialStart}
                initialEnd={initialEnd}
                onTimeDoubleClick={handleDoubleClick}
            />
        </div>
    );
};

export default InteractiveTimeline;